module.exports = __webpack_public_path__ + "img/sprinkle-9.f4cd0211.webp";